import { Currency } from "config/constants"
import i18n from "intl/i18n"

export interface IAmountWithCurrencyDto {
    amount: number
    currency: Currency
}

export default class AmountWithCurrency {
    amount: number
    currency: Currency

    constructor({
        amount,
        currency
    }: IAmountWithCurrencyDto) {
        this.amount = amount
        this.currency = currency
    }

    toDto(): IAmountWithCurrencyDto {
        return {
            amount: this.amount,
            currency: this.currency
        }
    }

    print(): string {
        return i18n.t('common.amountWithCurrency', {
            count: this.amount,
            currency: this.currency.toUpperCase()
        })
    }
}
